(function initializeCateringHomepage() {
  if (window.__cateringHomepageRedesignLoaded) return;
  window.__cateringHomepageRedesignLoaded = true;

  function setupCarousel(root) {
    const mediaPanels = Array.from(root.querySelectorAll('[data-catering-carousel-media]'));
    const copyPanels = Array.from(root.querySelectorAll('[data-catering-carousel-copy]'));
    const previous = root.querySelector('[data-catering-carousel-previous]');
    const next = root.querySelector('[data-catering-carousel-next]');
    if (!mediaPanels.length || mediaPanels.length !== copyPanels.length) return;
    let index = 0;

    function render(nextIndex) {
      index = (nextIndex + mediaPanels.length) % mediaPanels.length;
      mediaPanels.forEach((panel, panelIndex) => panel.classList.toggle('is-active', panelIndex === index));
      copyPanels.forEach((panel, panelIndex) => {
        const active = panelIndex === index;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
        panel.inert = !active;
      });
    }

    previous?.addEventListener('click', () => render(index - 1));
    next?.addEventListener('click', () => render(index + 1));
    render(0);
  }

  document.querySelectorAll('[data-catering-feature-carousel]').forEach(setupCarousel);

})();
